<!--
 * @Author: your name
 * @Date: 2019-11-19 10:56:07
 * @LastEditTime : 2019-12-19 14:27:09
 * @LastEditors  : Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: /newOfficeIndex/src/components/crsPart/titleContent.vue
 -->
<template>
  <div class="mainTitle" :style="{textAlign: msgObj.horizontal ? msgObj.horizontal : 'center'}">
    <p class="title">{{msgObj.title1}}</p>
    <span>____</span>
    <p class="subtitle" v-html="msgObj.title2"></p>
  </div>
</template>
<script>
export default {
  name: 'mainTitle',
  data () {
    return {}
  },
  props: {
    msgObj: {
      type: Object,
      default: () => {
        return {
          title1: null,
          title2: null,
          horizontal: ''
        }
      }
    }
  }
}
</script>
<style lang="scss">
.mainTitle{
  text-align: center;
  padding-bottom: .24rem;
  p{
  }
  .title{
    color: #444;
    font-size: 0.26rem;
    margin-bottom: .14rem;
  }
  span{
    color: #666;
  }
  .subtitle{
    color: #777;
    margin-top: .3rem;
    line-height: .36rem;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/DAWNING/titleContent.vue